<template>
  <TemplateView>
    <div class="d-flex justify-space-around">
      <div class="wrap" v-show="!$route.query.send" v-if="$vuetify.breakpoint.xlOnly ? true : edit">
        <div class="border">
          <div class="border__box">
            <div class="padding"></div>
            <v-form ref="form" class="box" v-model="valid" id="target">
              <div class="box_header">
                <div class="box_header_text f18 fw500">
                  {{ t.header }}
                  <span class="f18 fw500">
                    {{
                      $clientProjectNumber({
                        project_id: workClientProjectShow.id,
                        year: workClientProjectShow.year,
                        segment_letter: segmentLetter,
                      })
                    }}
                  </span>
                </div>
                <div class="box_header_date f14">
                  {{ new Date().toLocaleDateString() }}
                </div>
              </div>
              <div class="box_body">
                <div class="box_body_title">
                  <h4 class="f30 fw500">
                    {{
                      workClientProjectShow && workClientProjectShow.work_client
                        ? workClientProjectShow.work_client.name
                        : '—'
                    }}
                  </h4>
                  <span class="f16">{{ onShowClientAddress() }}</span>
                </div>
                <div class="box_body_info">
                  <div class="box_body_info_item">
                    <div class="box_body_info_item_title f16 fw500">
                      {{ t.project_name }}:
                    </div>
                    <div class="box_body_info_item_text f16">
                      {{ workClientProjectShow ? workClientProjectShow.name : '—' }}
                    </div>
                  </div>
                  <div class="box_body_info_item">
                    <div class="box_body_info_item_title f16 fw500">
                      {{ t.project_address }}:
                    </div>
                    <div class="box_body_info_item_text f16">
                      {{
                        workClientProjectShow
                          ? workClientProjectShow.street +
                            ', ' +
                            workClientProjectShow.zip +
                            ', ' +
                            workClientProjectShow.city
                          : '—'
                      }}
                    </div>
                  </div>
                  <div class="box_body_info_item">
                    <div class="box_body_info_item_title f16 fw500">
                      {{ t.contact_person }}:
                    </div>
                    <div class="box_body_info_item_text three f16">
                      <p>
                        {{
                          workClientPersonShow &&
                          (workClientPersonShow.last_name || workClientPersonShow.first_name)
                            ? workClientPersonShow.first_name + ' ' + workClientPersonShow.last_name
                            : '—'
                        }}
                      </p>
                      <p>
                        {{ workClientPersonShow ? workClientPersonShow.phone : '—' }}
                      </p>
                      <p>
                        {{ workClientPersonShow ? workClientPersonShow.email : '—' }}
                      </p>
                    </div>
                  </div>
                  <div class="box_body_info_item">
                    <div class="box_body_info_item_title f16 fw500">
                      {{
                        localStorage.translations.pages.sales_project['project_client-labels'][
                          'segment-vida-deyatelnosti'
                        ]
                      }}:
                    </div>
                    <div class="box_body_info_item_text f16">
                      {{
                        businessSegmentAll &&
                        businessSegmentAll.find(
                          (i) => i.id === workClientProjectShow.business_segment_id,
                        ) &&
                        businessSegmentAll.find(
                          (i) => i.id === workClientProjectShow.business_segment_id,
                        ).name
                      }}
                    </div>
                  </div>
                </div>
                <div class="box_body_table">
                  <table border="1" class="f16">
                    <tr>
                      <th class="fw500 text-center border-top border-left border-bottom">
                        {{
                          localStorage.translations.pages.sales_project['price_offer_terms-tables']
                            .title
                        }}
                      </th>
                      <th class="fw500 text-center border-top border-left border-bottom">
                        {{
                          localStorage.translations.pages.sales_project['price_offer_terms-tables']
                            .unit
                        }}
                      </th>
                      <th class="fw500 text-center border-top border-left border-bottom">
                        {{
                          localStorage.translations.pages.sales_project['price_offer_terms-tables']
                            .amount
                        }}
                      </th>
                      <th class="fw500 text-center border-top border-left border-bottom">
                        {{
                          localStorage.translations.pages.sales_project['price_offer_terms-tables']
                            .price_unit
                        }}
                      </th>
                      <th
                        class="fw500 text-center border-top border-left border-bottom border-right"
                        id="table_all"
                        ref="table_all"
                      >
                        {{
                          localStorage.translations.pages.sales_project['price_offer_terms-tables']
                            .in_total
                        }}
                      </th>
                    </tr>
                    <tr v-for="(item, index) in workClientProjectsWorkTypeAll_project" :key="index">
                      <td class="border-left border-bottom">
                        {{ item.work_type.name }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{
                          item.is_hourly
                            ? '€/' + localStorage.translations.pages.common.measure.hours_min
                            : item.work_type.measure
                        }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{
                          (item.is_hourly ? item.hours : item.size)
                            ? (item.is_hourly
                                ? Math.round((item.hours / 60) * 100) / 100
                                : item.size
                              ).toLocaleString('fi-FI', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : '-'
                        }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{
                          item.price > 0
                            ? item.price.toLocaleString('fi-FI', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : '-'
                        }}
                      </td>
                      <td align="center" nowrap class="border-left border-bottom border-right">
                        <span class="last-col">
                          {{
                            (item.is_hourly ? item.hours : item.size)
                              ? (
                                item.price *
                                  (item.is_hourly
                                    ? Math.round((item.hours / 60) * 100) / 100
                                    : item.size)
                              ).toLocaleString('fi-FI', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : '-'
                          }}
                        </span>
                        €
                      </td>
                    </tr>
                    <tr v-if="workClientProjectShow && workClientProjectShow.extra_works_price">
                      <td class="border-left border-bottom">
                        {{
                          localStorage.translations.pages.sales_project['sections']['price_extra']
                        }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{ '€/' + localStorage.translations.pages.common.measure.hours_min }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{ '-' }}
                      </td>
                      <td align="center" class="border-left border-bottom">
                        {{
                          workClientProjectShow.extra_works_price > 0
                            ? workClientProjectShow.extra_works_price.toLocaleString('fi-FI', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : '-'
                        }}
                      </td>
                      <td align="center" nowrap class="border-left border-bottom border-right">
                        <span class="last-col">
                          {{ '-' }}
                        </span>
                        €
                      </td>
                    </tr>
                  </table>
                  <div class="price f16 fw500">
                    {{
                      localStorage.translations.pages.sales_project['price_offer_terms-tables']
                        .in_total
                    }}
                    <div class="price_box">{{ onSum() }} €</div>
                  </div>
                </div>
                <div class="box_body_inputs" :class="{ read: false }">
                  <div class="box_body_inputs_item">
                    <ProjectProposedBreakPage
                      :key="key0"
                      :id="0"
                      :breaker="breaker"
                      :spacer="spacer"
                      :fnc-add-breaker="addBreaker"
                      :fnc-del-breaker="delBreaker"
                      :fnc-add-spacer="addSpacer"
                      :fnc-del-spacer="delSpacer"
                      class="mt-n5"
                    />
                    <label class="f14"> {{ t.price_in_euros }} </label>
                    <v-select
                      v-model="allData.project_offer_vat.value"
                      class="selectCustom"
                      height="44px"
                      :items="priceList"
                      :rules="[inputRules.required]"
                      append-icon="fas fa-angle-down"
                      menu-props="offset-y"
                      outlined
                      dense
                      @change="disable_vat = false"
                    >
                      <template slot="append-outer">
                        <v-btn
                          :disabled="!navigationGuardianActive == true && disable_vat == false
                          ? !navigationGuardianActive && (disable_vat = true)
                          : disable_vat"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_vat)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-select>
                  </div>
                  <ProjectProposedBreakPage
                    :key="key1"
                    :id="1"
                    :breaker="breaker"
                    :spacer="spacer"
                    :fnc-add-breaker="addBreaker"
                    :fnc-del-breaker="delBreaker"
                    :fnc-add-spacer="addSpacer"
                    :fnc-del-spacer="delSpacer"
                  />
                  <div class="box_body_inputs_item">
                    <label class="f14">
                      {{ t.commentary }}
                    </label>
                    <v-textarea
                      outlined
                      v-model="allData.project_offer_commentary.value"
                      auto-grow
                      rows="1"
                      :rules="[inputRules.required]"
                      @input="disable_commentary = false"
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_commentary == false
                          ? !navigationGuardianActive && (disable_commentary = true)
                          : disable_commentary"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_commentary)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                  <ProjectProposedBreakPage
                    :key="key2"
                    :id="2"
                    :breaker="breaker"
                    :spacer="spacer"
                    :fnc-add-breaker="addBreaker"
                    :fnc-del-breaker="delBreaker"
                    :fnc-add-spacer="addSpacer"
                    :fnc-del-spacer="delSpacer"
                  />
                  <div class="box_body_inputs_item">
                    <label class="f14">
                      {{ t.from_the_customer }}
                    </label>
                    <v-textarea
                      outlined
                      v-model="allData.project_offer_from_customer.value"
                      auto-grow
                      :rules="[inputRules.required]"
                      @input="disable_customer = false"
                      
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_customer == false
                          ? !navigationGuardianActive && (disable_customer = true)
                          : disable_customer"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_from_customer)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                  <ProjectProposedBreakPage
                    :key="key3"
                    :id="3"
                    :breaker="breaker"
                    :spacer="spacer"
                    :fnc-add-breaker="addBreaker"
                    :fnc-del-breaker="delBreaker"
                    :fnc-add-spacer="addSpacer"
                    :fnc-del-spacer="delSpacer"
                  />
                  <div class="box_body_inputs_item">
                    <label class="f14">
                      {{ t.from_the_contractor }}
                    </label>
                    <v-textarea
                      outlined
                      v-model="allData.project_offer_from_contractor.value"
                      auto-grow
                      :rules="[inputRules.required]"
                      @input="disable_contractor = false"
                      
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_contractor == false
                          ? !navigationGuardianActive && (disable_contractor = true)
                          : disable_contractor"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_from_contractor)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                  <ProjectProposedBreakPage
                    :key="key4"
                    :id="4"
                    :breaker="breaker"
                    :spacer="spacer"
                    :fnc-add-breaker="addBreaker"
                    :fnc-del-breaker="delBreaker"
                    :fnc-add-spacer="addSpacer"
                    :fnc-del-spacer="delSpacer"
                  />
                  <div class="box_body_inputs_item">
                    <label class="f14">
                      {{ t.offer_price_includes }}
                    </label>
                    <v-textarea
                      v-model="allData.project_offer_price_includes.value"
                      outlined
                      auto-grow
                      :rules="[inputRules.required]"
                      @input="disable_price = false"
                      
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_price == false
                          ? !navigationGuardianActive && (disable_price = true)
                          : disable_price"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_price_includes)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                  <ProjectProposedBreakPage
                    :key="key5"
                    :id="5"
                    :breaker="breaker"
                    :spacer="spacer"
                    :fnc-add-breaker="addBreaker"
                    :fnc-del-breaker="delBreaker"
                    :fnc-add-spacer="addSpacer"
                    :fnc-del-spacer="delSpacer"
                  />
                  <div class="box_body_inputs_item break-avoid w375">
                    <label class="f14">
                      {{ t.payment_method }}
                    </label>
                    <div class="box_body_inputs_item_wrap">
                      <v-select
                        class="selectCustom"
                        prepend-inner-icon="search"
                        outlined
                        dense
                        height="46px"
                        v-model="projectProposedData.maksutapa"
                        :items="maksutapaList"
                        item-value="id"
                        item-text="name"
                        append-icon="fas fa-angle-down"
                        menu-props="offset-y"
                        :rules="[inputRules.required]"
                        
                      />
                      <span class="f16">pv netto.</span>
                    </div>
                  </div>
                  <div class="box_body_inputs_item break-avoid w375">
                    <label class="f14">
                      {{ t.offer_valid }}
                    </label>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          prepend-inner-icon="today"
                          v-model="projectDateFormatted"
                          outlined
                          v-bind="attrs"
                          @blur="projectDate = parseDate(projectDateFormatted)"
                          :placeholder="localStorage.translations.pages.common['text'].not_selected"
                          v-on="on"
                          :rules="[inputRules.required]"
                        />
                      </template>
                      <v-date-picker
                        :locale="$cookies.get('languageSelect').key"
                        v-model="projectDate"
                        no-title
                        @input="menu1 = false"
                        :min="new Date().toISOString().slice(0, 10)"
                        first-day-of-week="1"
                        
                      />
                    </v-menu>
                  </div>
                  <div class="box_body_inputs_item">
                    <label class="f14">
                      {{ t.note }}
                    </label>
                    <v-textarea
                      outlined
                      v-model="allData.project_offer_notes.value"
                      :rows="3"
                      auto-grow
                      :placeholder="allData.project_offer_notes.value"
                      :rules="[inputRules.required]"
                      hide-details
                      @input="disable_notes = false"
                      
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_notes == false
                          ? !navigationGuardianActive && (disable_notes = true)
                          : disable_notes"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_notes)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                  <div class="box_body_inputs_item mt-5">
                    <v-textarea
                      outlined
                      v-model="allData.project_offer_sign.value"
                      :rows="3"
                      auto-grow
                      :placeholder="allData.project_offer_sign.value"
                      hide-details
                      @input="disable_sign = false"
                      
                    >
                      <template slot="append-outer">
                        <v-btn
                         :disabled="!navigationGuardianActive == true && disable_sign == false
                          ? !navigationGuardianActive && (disable_sign = true)
                          : disable_sign"
                          color="primary"
                          class="btn-pt"
                          depressed
                          @click="prepareData(allData.project_offer_sign)"
                        >
                          <BaseIcon width="20" height="20" icon="button-save" />
                        </v-btn>
                      </template>
                    </v-textarea>
                  </div>
                </div>
              </div>
            </v-form>
            <div class="padding" />
            <v-divider />
          </div>
        </div>
      </div>
      <div v-if="!edit" style="max-width: 800px; width: 100%">
        <ProjectProposedPdf
          :key="'pdf_cpm_' + pdfKey"
          ref="pdf"
          :on-show-client-address="onShowClientAddress"
          :on-sum="onSum"
          :project-proposed-data="projectProposedData"
          :segment-letter="segmentLetter"
          :project_offer_vat="allData.project_offer_vat.value"
          :project_offer_commentary="allData.project_offer_commentary.value"
          :project_offer_from_customer="allData.project_offer_from_customer.value"
          :project_offer_from_contractor="allData.project_offer_from_contractor.value"
          :project_offer_price_includes="allData.project_offer_price_includes.value"
          :project_offer_notes="allData.project_offer_notes.value"
          :project_offer_sign="allData.project_offer_sign.value"
          :project-date-formatted="projectDateFormatted"
          :file-name="fileName"
          :spacer="spacer"
          :breaker="breaker"
        />
        <div class="d-flex justify-center mt-8">
          <BaseButton
            @click="downloadPdf"
            default_icon="button-create_pdf"
            round
            size="68"
            icon_only
            class="mr-4"
          />
          <ProjectProposedModal
            :project="workClientProjectShow"
            :person="workClientPersonShow"
            :textTheme="fileName"
            :fileSend="fileSend"
            :functionGeneratePdf="generatePdf"
            class="ml-4"
          />
          <EditBtn v-if="!edit && $vuetify.breakpoint.lgAndDown" :fixed="true" :click="onEdit" />
        </div>
      </div>
      <div class="fixedBtn">
        <BaseTooltip
          :tooltip="localStorage.translations.pages.common['buttons']['sohranit']"
          max-content
          v-if="edit"
        >
          <BaseButton
            :disabled="!valid"
            @click="prepareAllData(allData)"
            round
            size="60"
            icon_only
            default_icon="button-save"
            class="mt-2"
          />
        </BaseTooltip>
      </div>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import EditBtn from 'components/EditBtn'
import TemplateView from 'components/templates/TemplateView'
import ProjectProposedModal from 'components/project/proposed/ProjectProposedModal'
import ProjectProposedBreakPage from '../../components/project/proposed/ProjectProposedBreakPage'
import ProjectProposedPdf from 'components/project/proposed/ProjectProposedPdf.vue'
import navigationGuardian from "@/store/modules/navigationGuardian";

export default {
  name: 'salesProjectProposed',
  components: {
    ProjectProposedPdf,
    ProjectProposedBreakPage,
    EditBtn,
    TemplateView,
    ProjectProposedModal,
  },
  data() {
    return {
      loading: false,
      loadingProgress: 0,
      valid: false,
      edit: true,
      menu1: false,
      projectDate: null,
      projectDateFormatted: null,
      priceList: ['ALV 0%', 'ALV 10%', 'ALV 14%', 'ALV 24%'],
      fileSend: null,
      spacer: [0, 0, 0, 0, 0, 0],
      breaker: [0, 0, 0, 0, 0, 0],
      key0: 0,
      key1: 1000,
      key2: 2000,
      key3: 3000,
      key4: 4000,
      key5: 5000,
      pdfKey: 0,
      loadingData: false,
      tableData: [],
      allData: {
        project_offer_vat: {
          name: 'project_offer_vat',
          value: '',
        },
        project_offer_commentary: {
          name: 'project_offer_commentary',
          value: '',
        },
        project_offer_from_customer: {
          name: 'project_offer_from_customer',
          value: '',
        },
        project_offer_from_contractor: {
          name: 'project_offer_from_contractor',
          value: '',
        },
        project_offer_price_includes: {
          name: 'project_offer_price_includes',
          value: '',
        },
        project_offer_notes: {
          name: 'project_offer_notes',
          value: '',
        },
        project_offer_sign: {
          name: 'project_offer_sign',
          value: '',
        },
      },
      disable_vat: true,
      disable_commentary: true,
      disable_customer: true,
      disable_contractor: true,
      disable_price: true,
      disable_notes: true,
      disable_sign: true,
      fieldsLabels: [
        'project_offer_commentary',
        'project_offer_from_customer',
        'project_offer_from_contractor',
        'project_offer_price_includes',
        'project_offer_notes',
        'project_offer_sign',
        'project_offer_vat',
      ],
    }
  },
  computed: {
    navigationGuardian() {
      return navigationGuardian
    },
    ...mapState(['configData', 'apiDomain']),
    ...mapGetters(['inputRules']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workClientPerson', ['workClientPersonShow']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
    ...mapGetters('workBusinessSegment', ['businessSegmentAll']),
    ...mapGetters('workClient', ['workClientShow']),
    ...mapGetters('workClientAddress', ['workClientAddressGrid']),
    ...mapGetters('commonContent', ['contentData', 'allContentData', 'categoryContentData']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    t() {
      return this.localStorage.translations.pages.sales_project['price_offer_terms-labels']
    },
    projectProposedData() {
      return {
        maksutapa: '',
      }
    },
    maksutapaList() {
      const max = 60
      let array = []
      for (let i = 1; i <= max; i++) {
        array.push(i)
      }
      return array
    },
    segmentLetter() {
      let result = null
      if (
        this.businessSegmentAll.length &&
        this.workClientProjectShow &&
        this.workClientProjectShow.business_segment_id
      ) {
        result = this.businessSegmentAll
          .find((i) => i.id === this.workClientProjectShow.business_segment_id)
          .name.substr(0, 1)
      }
      return result
    },
    fileName() {
      let result = null
      if (this.workClientProjectShow.work_client) {
        result =
          this.t.header +
          ' ' +
          this.$clientProjectNumber({
            project_id: this.workClientProjectShow.id,
            year: this.workClientProjectShow.year,
            segment_letter: this.segmentLetter,
          }) +
          ' ' +
          this.workClientProjectShow.work_client.name +
          ' ' +
          this.workClientProjectShow.name
      }

      return result
    },
  },
  created() {
    this.getTemplateContentData()
    this.onCheckChange({ overwrite: true })
    this.loadingData = true
    Promise.all([
      this.onWorkClientProjectShow(this.$route.params.id),
      this.onWorkClientProjectsWorkTypeAll_project(this.$route.params.id),
      this.onBusinessSegmentAll(),
    ]).then(() => {
      this.loadingData = false
    })
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    allData: {
      handler() {
        this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
    projectDate(val) {
      this.projectDateFormatted = this.$formatDate(this.projectDate)
    },
    workClientProjectShow() {
      if (this.workClientProjectShow) {
        if (this.workClientProjectShow.responsible_client_person_id) {
          this.onWorkClientPersonShow(this.workClientProjectShow.responsible_client_person_id)
        }
        if (this.workClientProjectShow.work_client) {
          this.onWorkClientShow(this.workClientProjectShow.work_client.id)
          this.onWorkClientAddressGrid({
            limit: '0',
            page: 1,
            id: this.workClientProjectShow.work_client.id,
          })
        }
      }
    },
    loadingData() {
      if (this.loadingData) {
        this.setLoadingAnimationFullPage(true)
      } else {
        this.setLoadingAnimationFullPage(false)
      }
    },
  },
  methods: {
    ...mapActions('workClientAddress', ['onWorkClientAddressGrid']),
    ...mapActions('workClientProject', ['onWorkClientProjectShow', 'onWorkClientProjectUpdate']),
    ...mapActions('workClientPerson', ['onWorkClientPersonShow']),
    ...mapActions('workClientProjectsWorkType', ['onWorkClientProjectsWorkTypeAll_project']),
    ...mapActions('workClient', ['onWorkClientShow']),
    ...mapActions('workBusinessSegment', ['onBusinessSegmentAll']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    ...mapActions('commonContent', ['onGetCategoryContent', 'onChangeContentData',]),
    async getTemplateContentData() {
      let data = {
        category: 'project_offer',
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      await this.onGetCategoryContent(data).then((res) => {
        let temp = res.data.data.map((i) => i.name)
        for (let i in this.fieldsLabels) {
          let index = temp.indexOf(this.fieldsLabels[i])
          this.allData[this.fieldsLabels[i]].value = res.data.data[index].value
        }
        this.onCheckChange({ overwrite: true })
        
      })
    },
    prepareData(data) {
      let result = {
        content: [
          {
            category: 'project_offer',
            name: data.name,
            value: data.value,
          },
        ],
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      this.updateData(result)
    },
    prepareAllData(data) {
      let result = {
        content: [
          {
            category: 'project_offer',
            name: Object.values(data)[0].name,
            value: Object.values(data)[0].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[1].name,
            value: Object.values(data)[1].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[2].name,
            value: Object.values(data)[2].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[3].name,
            value: Object.values(data)[3].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[4].name,
            value: Object.values(data)[4].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[5].name,
            value: Object.values(data)[5].value,
          },
          {
            category: 'project_offer',
            name: Object.values(data)[6].name,
            value: Object.values(data)[6].value,
          },
        ],
        contentable_type: 'project',
        contentable_id: this.$route.params.id,
      }
      let multi_field = true
      this.updateData(result, multi_field)
    },
    async updateData(data, multi_field) {
      this.fieldsDisabled()
      await this.onChangeContentData(data)
        .then(() => {
          this.getTemplateContentData()
          this.onSave()
          this.pdfKey++
          if (multi_field) {
            this.$store.dispatch(
             'popup/onMessage',
             {
               message:
                this.localStorage.translations.pages.common.notifications[
                 'izmeneniya-uspeshno-sohraneny'
                 ],
               IsError: false,
             },
             { root: true },
            )
            this.dialog = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    fieldsDisabled() {
      this.disable_vat = true
      this.disable_commentary = true
      this.disable_customer = true
      this.disable_contractor = true
      this.disable_price = true
      this.disable_notes = true
      this.disable_sign = true
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onShowClientAddress() {
      const clientAddress =
        this.workClientShow &&
        this.workClientShow.registration_street &&
        this.workClientShow.registration_zip &&
        this.workClientShow.registration_city
          ? this.workClientShow.registration_street +
            ', ' +
            this.workClientShow.registration_zip +
            ', ' +
            this.workClientShow.registration_city
          : '—'
      if (this.workClientProjectShow && this.workClientProjectShow.work_client_office_id) {
        if (this.workClientAddressGrid.length) {
          const office = this.workClientAddressGrid.find(
            (i) => i.office && i.office.id === this.workClientProjectShow.work_client_office_id,
          )
          return office ? office.street + ', ' + office.zip + ', ' + office.city : clientAddress
        } else return clientAddress
      } else {
        return clientAddress
      }
    },
    onSum() {
      let sum = this.workClientProjectsWorkTypeAll_project.reduce((sum, current) => {
        let temp =
          current.price *
          (current.is_hourly ? Math.round((current.hours / 60) * 100) / 100 : current.size)
        if (temp) {
          return sum + temp
        } else return sum
      }, 0)
      return sum > 0
        ? sum.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '-'
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { projectOfferSettings: this.allData },
        overwrite,
      })
    },
    async generatePdf() {
      if (this?.$refs['pdf']?.$refs['pdf-gen']) {
        this.fileSend = this.$refs['pdf'].$refs['pdf-gen'].getBlob()
        this.onNavigationGuardianCheck({
          data: { projectOfferSettings: this.allData },
          overwrite: true,
        })
      }
    },
    downloadPdf() {
      if (this?.$refs['pdf']?.$refs['pdf-gen']) this.$refs['pdf'].$refs['pdf-gen'].onDownload()
    },
    validate() {
      return this.$refs.form.validate()
    },
    onSave() {
      if (this.validate()) {
        this.onNavigationGuardianCheck({
          data: { projectOfferSettings: this.allData },
          overwrite: true,
        })
        this.fileSend = null
        this.edit = false
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      }
    },
    onEdit() {
      this.edit = true
    },
    addSpacer(id) {
      this.spacer[id]++
      this['key' + id]++
      this.pdfKey++
    },
    addBreaker(id) {
      this.breaker[id]++
      this['key' + id]++
      this.pdfKey++
    },
    delSpacer(id) {
      this.spacer[id]--
      this['key' + id]++
      this.pdfKey++
    },
    delBreaker(id) {
      this.breaker[id]--
      this['key' + id]++
      this.pdfKey++
    },
  },
}
</script>

<style lang="scss" scoped>
.black-color {
  :deep() * {
    color: black !important;
  }
}

.wrap {
  max-width: 950px;
  width: 100%;

  .btns {
    display: flex;
    justify-content: flex-start;

    &.center {
      display: grid;
      grid-template-columns: repeat(2, max-content);
      column-gap: 30px;
      justify-content: center;
    }
  }
}

.border {
  border: 1px solid #bedbeb;
  background-color: #fcfcfc;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin: 0 8px;
  }

  &-top {
    border-top: 1px solid black;
  }

  &-right {
    border-right: 1px solid black;
  }

  &-bottom {
    border-bottom: 1px solid black;
  }

  &-left {
    border-left: 1px solid black;
  }
}

.text-center {
  text-align: center !important;
}

.padding {
  padding-bottom: 30px;
}

.break-avoid {
  break-inside: avoid;
}

.box {
  color: #000000 !important;
  // page-break-before: avoid;

  &_header {
    display: flex;
    justify-content: space-between;
    padding: 0 30px 30px 30px;
    border-bottom: 1px solid #bedbeb;
    align-content: center;
    align-items: center;

    &_text {
      display: grid;
      grid-template-columns: max-content max-content;
      column-gap: 8px;
      align-items: center;
    }
  }

  &_body {
    padding: 30px 30px 0;
    display: grid;
    row-gap: 30px;

    @media #{map-get($display-breakpoints, 'sm-only')} {
      padding: 15px 15px 0;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 4px 4px 0;
    }

    &_title {
      display: grid;
      gap: 14px;
      margin-bottom: 30px;
    }

    &_info {
      display: grid;
      row-gap: inherit;

      &_item {
        display: grid;
        grid-template-columns: 170px auto;
        column-gap: 10px;

        &_title {
          height: max-content;
        }

        &_text {
          &.three {
            display: grid;
            row-gap: 8px;

            p {
              margin: 0;
            }
          }
        }
      }
    }

    &_table {
      margin-bottom: 10px;

      &_title {
        margin-bottom: 30px;
      }

      table {
        border-collapse: collapse;
        border-color: transparent;

        th,
        td {
          &:first-of-type {
            width: 529px;
          }

          &:last-of-type {
            width: max-content;
          }
        }

        th {
          text-align: start;
          padding: 14px 10px;
          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            padding: 8px 2px;
          }

          @media #{map-get($display-breakpoints, 'xs-only')} {
            font-size: 10px;
          }

          &:first-of-type {
            padding: 14px 20px;
            @media #{map-get($display-breakpoints, 'sm-and-down')} {
              padding: 2px;
            }
          }
        }

        td {
          padding: 10px;
          @media #{map-get($display-breakpoints, 'sm-and-down')} {
            padding: 6px 2px;
          }

          @media #{map-get($display-breakpoints, 'xs-only')} {
            font-size: 10px;
          }

          &:first-of-type {
            padding: 10px 20px;
            @media #{map-get($display-breakpoints, 'sm-and-down')} {
              padding: 6px 2px;
            }
          }
        }
      }

      .price {
        margin-top: 15px;
        display: grid;
        grid-template-columns: max-content max-content;
        column-gap: 14px;
        align-items: center;
        justify-content: flex-end;
        break-inside: avoid;

        &_box {
          border: 1px solid black;
          padding: 10px;
          text-align: center;
        }
      }
    }

    &_inputs {
      display: grid;

      &.read {
        display: grid;
        row-gap: 30px;
      }

      &_item {
        label {
          line-height: 2.6rem;
        }

        &.w375 {
          width: 375px;
        }

        &_wrap {
          display: grid;
          grid-template-columns: auto max-content;
          column-gap: 10px;

          span {
            margin-top: 14px;
          }
        }
      }
    }
  }
}

.btn-pt {
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
}
</style>